import Providers from "./Providers";
import Routing from "./app/routing/Routing";

const App = () => {
  return <Providers children={<Routing />} />;
};

export default App;
